import { Component, OnInit } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInLeft, fadeInRight, slideInUp, fadeInDown } from 'ng-animate';
@Component({
  selector: 'app-skills',
  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.scss'],
  animations: [
    trigger('fadeInRight', [transition('* => *', useAnimation(fadeInRight))]),
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown))]),
    trigger('fadeInLeft', [transition('* => *', useAnimation(fadeInLeft))]),
    trigger('slideInUp', [transition('* => *', useAnimation(slideInUp))])
  ],
})
export class SkillsComponent implements OnInit {
  fadeInRight;
  fadeInLeft;
  fadeInDown;
  slideInUp;
  pythonValue = 75;
  angularValue = 83;
  restValue = 80;
  ngrxValue = 60;
  mongoValue = 60;
  sqlValue = 45;
  machineValue = 45;
  gitValue = 70;
  expressValue = 70;
  datastructuresValue = 65;
  thumbLabel = true
  constructor() { }

  ngOnInit(): void {
  }

}
